import { Col, Row } from "reactstrap"
import styles from "./KPIChartStats.module.scss"
import RoundedColoredDiv from "../RoundedColoredDiv/RoundedColoredDiv"

const KPIChartStats = ({ data }) => {
  return (
    <>
      <Row className="gy-2">
        {data?.map((item, index) => (
          <Col key={index} xs={12}>
            <Row className="align-items-center">
              <Col className="d-flex align-items-center gap-2">
              <RoundedColoredDiv backgroundColor={item?.divColor} />
                <div className={styles["text-gray"]}>{item?.device}</div>
              </Col>
              <Col>
                <div className={styles["green-bg"]}>{item?.sales}</div>
              </Col>
              <Col className={styles["text-gray"]}>
                {item?.percentage}
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </>
  )
}

export default KPIChartStats
